import { c as _c } from "react/compiler-runtime";
import type { Entity, EntityOnboarding } from '@onefootprint/request-types/dashboard';
import { useDecryptOnboarding, useDecryptOnboardingDocuments } from '@/components/entity-onboarding-details';
import type useEntityVault from '@/entities/hooks/use-entity-vault';
import type { DecryptAction } from '../../../decrypt-all-button';
type UseDecryptAllProps = {
  entity: Entity;
  onboarding: EntityOnboarding;
  vault: ReturnType<typeof useEntityVault>;
  /** What "Decrypt all" can do for the vault. Unset while the attributes load. */
  vaultDecrypt?: {
    isNeeded: boolean;
    canDecrypt: boolean;
  };
};

/** "Decrypt all" for an onboarding: unset once nothing it collected is left encrypted, and 'pending' until that's known. */
const useDecryptAll = t0 => {
  const $ = _c(15);
  const {
    entity,
    onboarding,
    vault,
    vaultDecrypt
  } = t0;
  let t1;
  if ($[0] !== entity || $[1] !== onboarding || $[2] !== vault.data || $[3] !== vault.isDecryptable || $[4] !== vault.update) {
    t1 = {
      entity,
      onboarding,
      onDecryptSuccess: vault.update,
      vaultData: vault.data,
      isDecryptable: vault.isDecryptable
    };
    $[0] = entity;
    $[1] = onboarding;
    $[2] = vault.data;
    $[3] = vault.isDecryptable;
    $[4] = vault.update;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const {
    decrypt: decryptVault,
    isDecrypting: isVaultDecrypting
  } = useDecryptOnboarding(t1);
  const documentsDecrypt = useDecryptOnboardingDocuments(entity, onboarding);
  if (!vaultDecrypt || documentsDecrypt.isPending) {
    return "pending";
  }
  if (!vaultDecrypt.isNeeded && !documentsDecrypt.hasEncryptedDocuments) {
    return;
  }
  const canDecryptDocuments = documentsDecrypt.hasEncryptedDocuments && documentsDecrypt.canDecrypt;
  const t2 = vaultDecrypt.canDecrypt || canDecryptDocuments;
  const t3 = isVaultDecrypting || documentsDecrypt.isDecrypting;
  let t4;
  if ($[6] !== canDecryptDocuments || $[7] !== decryptVault || $[8] !== documentsDecrypt || $[9] !== vaultDecrypt.canDecrypt) {
    t4 = async () => {
      await Promise.all([vaultDecrypt.canDecrypt && decryptVault(), canDecryptDocuments && documentsDecrypt.decrypt()]);
    };
    $[6] = canDecryptDocuments;
    $[7] = decryptVault;
    $[8] = documentsDecrypt;
    $[9] = vaultDecrypt.canDecrypt;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t2 || $[12] !== t3 || $[13] !== t4) {
    t5 = {
      canDecrypt: t2,
      isDecrypting: t3,
      onDecrypt: t4
    };
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};
export default useDecryptAll;